import { AssetsTab } from './canvas-ad-library-view';

/**
 * Assets — a top-level sidebar view (v6.39). Brand folders are the default
 * level; opening one lists that brand's generated creatives. The grid itself
 * lives in AssetsTab, shared with nothing else now that the Ad library tab
 * has been retired in favour of this standalone page.
 */
export function CanvasAssetsView() {
  return (
    <div
      data-testid="canvas-assets-view"
      style={{ height: '100%', display: 'flex', flexDirection: 'column', background: 'transparent', fontFamily: 'system-ui, sans-serif' }}
    >
      <div style={{ background: '#FFFFFF', borderBottom: '1px solid #DCE3ED', padding: '12px 20px 10px', flexShrink: 0 }}>
        <h1 className="workspace-page-title">Saved creatives</h1>
        <p className="workspace-page-description">Your generated ads, organized by brand. Open a creative to review, download, or reuse it.</p>
      </div>
      <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <AssetsTab />
      </div>
    </div>
  );
}
